import PropTypes, { bool } from "prop-types";
import React, { forwardRef } from "react";

import styled from "styled-components/macro";

import { Input, Label } from "./Styles";

export const CityField = forwardRef(function CityField(
  {
    value = "",
    onChange,
    onBlur,
    label = "City",
    name = "city",
    placeholder = "City",
    hideInternalFocusStyles = false,
    autoComplete = "off",
    style,
    disabled,
  },
  ref
) {
  return (
    <Wrapper style={style}>
      <Label htmlFor={name}>{label}</Label>
      <Input
        ref={ref}
        id={name}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        hideInternalFocusStyles={hideInternalFocusStyles}
        autoComplete={autoComplete}
        disabled={disabled}
      />
    </Wrapper>
  );
});

CityField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  label: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  autoComplete: PropTypes.oneOf(["on", "off"]),
  style: PropTypes.object,
  disabled: bool,
};

const Wrapper = styled.div`
  box-sizing: border-box;
  border-right: 1px solid #e5e5e5;
  padding: 6px;
  flex: 1;
  min-width: 120px;

  @media (max-width: 430px) {
    width: 100%;
    border-bottom: 1px solid #e5e5e5;
    height: 45.5px;
  }
`;
